function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 9,
  y: 9,
  width: 13,
  height: 13,
  rx: 2,
  ry: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0094dd",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "arcs"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/code.8b7d0ac7.svg";
export { SvgComponent as ReactComponent };